import { InjectionToken } from '@angular/core';

import { PreviewMediaStoreContract } from '../models/preview-media-store-contract.interface';

export const PREVIEW_MEDIA_STORE = new InjectionToken<PreviewMediaStoreContract>('PREVIEW_MEDIA_STORE');
